const DialogEvent = {};
export default DialogEvent;

DialogEvent.START_STATE_CHANGED = "START_STATE_CHANGED";
DialogEvent.TIME_OUT_STATE_CHANGED = "TIME_OUT_STATE_CHANGED";
DialogEvent.STATE_ADDED = "STATE_ADDED";
DialogEvent.TRANSITION_ADDED = "TRANSITION_ADDED";
DialogEvent.STATE_REMOVED = "STATE_REMOVED";
DialogEvent.TRANSITION_REMOVED = "TRANSITION_REMOVED";

DialogEvent.DATA_CHANGED = "DATA_CHANGED";
DialogEvent.EXECUTE_ONCE_CHANGED = "EXECUTE_ONCE_CHANGED";
DialogEvent.CONDITION_CHANGED = "CONDITION_CHANGED";
DialogEvent.META_DATA_CHANGED = "META_DATA_CHANGED";

DialogEvent.COMMAND_ADDED = "COMMAND_ADDED";
DialogEvent.OPTION_TARGET_CHANGED = "OPTION_TARGET_CHANGED";
DialogEvent.OPTION_ADDED = "OPTION_ADDED";
DialogEvent.OPTION_REMOVED = "OPTION_REMOVED";
DialogEvent.TRANSITION_TARGET_CHANGED = "TRANSITION_TARGET_CHANGED";